document.addEventListener("DOMContentLoaded", () => {
  let pageNum = 1;
  let loading = false;
  let activeFunction = true

  const loadMoreBtn = document.getElementById("load-more-btn-collection");
  const container = document.querySelector("product-list.product-list");

  if(!loadMoreBtn) return null

  const loadProducts = async () => {
    try {
      const response = await fetch(`${window.location.href}?page=${pageNum}`);
      const doc = await response.text();
      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(doc, "text/html");
      const products = htmlDoc.querySelectorAll(".product-card");
      const productsNew = htmlDoc.querySelector('product-list')

      if(productsNew.childNodes.length != 0 ){
        container.append(...products);
        pageNum++;
        loading = false;
        loadMoreBtn.innerHTML = `
          <div class="view_all_button">
          <span>View all</span>
          <span class="arrow-down">
            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="Vector" d="M1.03003 1.32442L4.03003 4.32442L7.03003 1.32442" stroke="#252525" stroke-width="1.5"/>
            </svg>
          </span>
        </div>
        `;
      }else{
        loadMoreBtn.style.display = "none";
      }

      

    } catch (error) {
      console.error(error);
    }
  };

  loadMoreBtn.addEventListener("click", (evt) => {
    evt.preventDefault();
    if (!loading) {
      loading = true;
      loadMoreBtn.innerHTML = `
        <div class="view_all_button">
          <span>View all</span>
          <span class="arrow-down">
            <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path id="Vector" d="M1.03003 1.32442L4.03003 4.32442L7.03003 1.32442" stroke="#252525" stroke-width="1.5"/>
            </svg>
          </span>
        </div>
      `;
      loadProducts();
    }
  });
});


window.addEventListener("scroll", function() {
  if ((window.innerHeight + 800) + window.scrollY >= document.body.offsetHeight) {
    var loadMoreBtn = document.getElementById("load-more-btn-collection");
    if (loadMoreBtn) {
      loadMoreBtn.click();
    }
  }
});
var loadMoreBtn = document.getElementById("load-more-btn-collection");
if(!!loadMoreBtn) loadMoreBtn.style.display = "none";

document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.swiper__product-grid', {
    direction: 'horizontal',
    breakpoints: {
      320: {
        slidesPerView: 2.4,
        spaceBetween: 15
      },
      648: {
        slidesPerView: 3.2,
        spaceBetween: 15,
      },
      968: {
        slidesPerView: 3.2,
        spaceBetween: 15,
      }
    },
    navigation: {
      nextEl: '.swiper__product-grid .swiper-button-next',
      prevEl: '.swiper__product-grid .swiper-button-prev',
    },
  });

  new Swiper('.navigation-collection .swiper', {
    direction: 'horizontal',
    breakpoints: {
      320: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },
      968: {
        slidesPerView: 'auto',
        spaceBetween: 20,
      }
    }
  });
})